(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/rounds/views/round-item.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/rounds/views/round-item.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.app.productStartPage.rounds.views.RoundItem = Backbone.Marionette.View.extend({
    tagName: 'div',
    className:
        'round-item-flex js-clickable js-clickable-delayed-click clickable-list-item-product-start-page-rounds',
    events: {
      click: 'onClick'
    },
    template: function(data) {
      return svs.app.product_start_page.templates.default_round_flex(data);
    },
    onBeforeAttach: function() {
      if (this.model.get('useBackground')) {
        var $content = this.$el.find('.round-item-flex-content');
        $content.addClass('background-sport');

        if (
          this.model.get('matches')[0] &&
            this.model.get('matches')[0].sport
        ) {
          if (!this.model.get('matches')[0].sport.isMixed) {
            $content.addClass('background-sport-' + this.model.get('matches')[0].sport.sportId);
          }
        }
      }
      if (this.model.get('empty')) {
        this.$el
          .addClass('round-item-flex-empty')
          .removeClass('js-clickable js-clickable-delayed-click clickable-list-item-product-start-page-rounds');
      } else if (this.model.get('last')) {
        this.$el.addClass('round-item-flex-last');
      }
    },
    onClick: function() {
      if (this.model.get('callback') && !this.model.get('empty')) {
        this.model.get('callback')();
      }
    }
  });
})(Backbone, _, svs);

 })(window);